import { BaseEntity } from './base-entity';

export type ColorToken =
  | 'blue'
  | 'bluegray'
  | 'cyan'
  | 'gray'
  | 'green'
  | 'indigo'
  | 'orange'
  | 'pink'
  | 'purple'
  | 'red'
  | 'teal'
  | 'yellow';

export const COLOR_TOKENS: ColorToken[] = [
  'blue',
  'cyan',
  'teal',
  'green',
  'yellow',
  'orange',
  'red',
  'pink',
  'purple',
  'indigo',
  'bluegray',
  'gray',
];

export interface Topic extends BaseEntity {
  workspaces: string[];
  title: string;
  description: string;
  icon: string;
  defaultBookmark: string;
  categories: string[];
  bookmarkCategories: string[];
  published: boolean;
  visibleInInternalAtlas: boolean;
  sorting: number;
  spotlight: boolean;
  color?: ColorToken;
}
